import { useSelector } from 'react-redux';
import { State } from '../core/reducers';
import { useActiveFeature } from './useActiveFeature';
import { Feature } from '@api/v1';

export const useIsNewJanitor = () => {
	const isNewJanitorPricing = useActiveFeature(Feature.JanitorNewPricing);
	const { account } = useSelector((state: State) => state.admin.account);
	if (!account) return undefined;
	return !!(account?.category === 'FACILITY_MANAGEMENT' && isNewJanitorPricing);
};
